const emojioneExtension = emojione => [
  {
    type: 'output',
    filter: text => emojione.toImage(text),
  },
];

export default emojioneExtension;
